import { POST, PUT } from '../../utils/axios-interceptor';
import axios from 'axios';

export const fetchFilteredViews = (payload: { pnoId: string; source: string }) => {
    return axios({
        url: API_ENDPOINTS.GET_FILTERED_VIEWS,
        method: POST,
        data: payload,
    });
};

export const createFilteredView = (payload: {
    viewName: string;
    pnoId: string;
    source: string;
    filters: any;
    userId: string;
    columns?: string[];
}) => {
    return axios({
        url: API_ENDPOINTS.CREATE_FILTERED_VIEW,
        method: POST,
        data: payload,
    });
};

export const updateFilteredView = (payload: { viewId: string; filters: any; userId: string; viewName?: string; columns?: string[] }) => {
    return axios({
        url: API_ENDPOINTS.UPDATE_FILTERED_VIEW,
        method: POST,
        data: payload,
    });
};

const API_ENDPOINTS = {
    GET_FILTERED_VIEWS: 'filteredViews/get',
    CREATE_FILTERED_VIEW: 'filteredViews/create',
    UPDATE_FILTERED_VIEW: 'filteredViews/update',
};
